interface Config {
  API_URL: string;
}

export const config: Config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://api.fidhub.com.br',
};

